export default { sha: 'e646cecd8d2abed3a37fb6f3a6f10bdaaa01fa32', buildNumber: 'undefined' }
